import React from 'react';
import { Outlet } from "react-router-dom";
import { Layout, theme } from "antd";

const { Header, Content, Footer } = Layout;

export default function ProjectLayout() {
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

    return (
        // <div style={{ borderRadius: borderRadiusLG, background: colorBgContainer }} className="mx-auto max-w-none bg-surface min-h-[calc(100vh-64px)]">
            <Layout style={{ borderRadius: borderRadiusLG, background: colorBgContainer }} className="mx-auto max-w-none bg-surface min-h-[calc(100vh-64px)]">
                <Outlet />
            </Layout>
        // </div>
    );
}